/* 
  APPLY FILTER
*/

function getSelectedValues(groupName) {
  const checkboxes = document.querySelectorAll(`input[name=${groupName}]:checked`);
  return Array.from(checkboxes, checkbox => checkbox.value);
}

function processSelectedItems(selectedItems) {
  const itemList = Array.from(document.getElementById("people-listing").getElementsByClassName("people-listing-item"));
  
  itemList.forEach((li) => {
      if (selectedItems.length > 0) {
        const dataId = li.getAttribute("data-tags");
        const idArray = dataId.split(',').map(id => id.trim());
        const match = idArray.some(id => selectedItems.includes(id));
        if (match) {
            li.style.display = "flex"; // Show the matching items
        } else {
            li.style.display = "none"; // Hide the non-matching
        }
      }
  });

}

const checkboxes = document.querySelectorAll('.people-checkbox');
function handleCheckboxClick(event) {

  if (event.target.id == 'people-checkbox0') {
    if (event.target.checked == true) {
      checkboxes.forEach(checkbox => {
        if (checkbox !== event.target) {
          checkbox.checked = true;
        }
      });
    } else {
      checkboxes.forEach(checkbox => {
        if (checkbox !== event.target) {
          checkbox.checked = false;
        }
      });
    }
  }
  
  applySelections();
}

function applySelections()
{

  // Create an array to hold all selected values
  const selectedItems = [];

  // Get selected values for each group and add them to the selectedItems array
  selectedItems.push(...getSelectedValues("people-checkbox"));

  // Call your function and pass the combined selectedItems array
  processSelectedItems(selectedItems);

  // document.getElementById("applyButton").addEventListener("click", function() {
  //   // Create an array to hold all selected values
  //   const selectedItems = [];

  //   // Get selected values for each group and add them to the selectedItems array
  //   selectedItems.push(...getSelectedValues("people-checkbox"));

  //   // Call your function and pass the combined selectedItems array
  //   processSelectedItems(selectedItems);
  // });
}

document.addEventListener('DOMContentLoaded', function() {

  const singlePeopleDiv = document.querySelector(".single-people");

  if (singlePeopleDiv) {
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('click', handleCheckboxClick);
    });
  }

});